import { useState } from "react";
import { useForm } from "react-hook-form";
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner,
} from "reactstrap";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import FileUploader from "./FileUploader";

const AddInvoiceDocumentModal = ({ modal, toggle, modalData, GetPaymentTicketDetail }) => {
    // console.log("modalData>>>>>>>>",modalData);
    const [isLoading, setIsLoading] = useState(false);
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            invoiceNumber: '',
            invoiceFile: '',
        }
    });


    const invoiceFile = watch("invoiceFile");

    const closeHandler = () => {
        toggle();
        reset();
    };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            file.preview = URL.createObjectURL(file);
            setValue("invoiceFile", file);
        }
    };

    const handleRemoveFile = () => {
        setValue("invoiceFile", null);
    };

    const onSubmit = (data) => {
        if (!data.invoiceFile) {
            toast.error("Please upload an invoice document");
            return;
        }

        const formData = new FormData();
        formData.append("Inv", data?.invoiceFile);

        const options = {
            method: "POST",
            form_data: formData,
        };
        let API = apiUrl?.upload_payment_ticket_invoice + "?paymentTicketId=" + modalData?.id;
        setIsLoading(true);
        callApi(API, options).then((response) => {
            setIsLoading(false);
            if (response?.status === true) {
                toast.success(response?.message);
                GetPaymentTicketDetail();
                closeHandler();
            } else {
                toast.error(response?.message);
            }
        });
    };

    return (
        <Modal
            className="modal-dialog modal-dialog-scrollable modal-dialog-centered"
            isOpen={modal}
            toggle={closeHandler}
            centered
            size="lg"
        >
            <ModalHeader toggle={closeHandler}>
                <h3>Add Invoice Document</h3>
            </ModalHeader>

            <form onSubmit={handleSubmit(onSubmit)}>
                <ModalBody className="p-4">
                    <div className="d-flex align-items-center justify-content-center">
                        <FileUploader
                            label="Invoice"
                            inputId="invoice-upload"
                            file={invoiceFile}
                            onFileChange={handleFileChange}
                            onRemoveFile={handleRemoveFile}
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={closeHandler}
                    >
                        Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                        {isLoading ? <Spinner /> : "Add Document"}
                    </button>
                </ModalFooter>
            </form>
        </Modal>
    );
};

export default AddInvoiceDocumentModal;
